import { BANNER_CONTAINER } from '../Banner';
import { Flip, ToastContainer } from 'react-toastify';
import React from 'react';
import style from './banner-holder.module.scss';
import clsx from 'clsx';
import '../transitions.css';

type BannerHolderProps = {
  customBanner?: React.ReactNode;
  outerClassName?: string;
  innerClassName?: string;
};

export const BannerHolder = ({
  customBanner,
  outerClassName,
  innerClassName
}: BannerHolderProps) => {
  return (
    <div className={clsx(style.bannerHolder, outerClassName)}>
      {customBanner ? customBanner : null}
      <ToastContainer
        position='top-left'
        autoClose={false}
        hideProgressBar={true}
        closeButton={false}
        newestOnTop={true}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={true}
        draggable={false}
        pauseOnHover={true}
        transition={Flip}
        className={clsx(style.bannerHolderInner, innerClassName)}
        containerId={BANNER_CONTAINER}
      />
    </div>
  );
};
